interface RankingItem {
  rank: number;
  title: string;
  heat: string;
  tag: string;
  trend: 'up' | 'down' | 'new' | 'hot';
}

const rankingData: RankingItem[] = [
  {
    rank: 1,
    title: '顶流艺人私下言论录音曝光事件',
    heat: '9,876,543',
    tag: '娱乐圈',
    trend: 'hot',
  },
  {
    rank: 2,
    title: '知名网红直播间翻车言论全网抵制',
    heat: '8,234,109',
    tag: '网红圈',
    trend: 'up',
  },
  {
    rank: 3,
    title: '热门综艺录制现场冲突视频',
    heat: '7,651,288',
    tag: '综艺',
    trend: 'hot',
  },
  {
    rank: 4,
    title: '某大导新片选角潜规则内幕',
    heat: '6,432,901',
    tag: '娱乐圈',
    trend: 'new',
  },
  {
    rank: 5,
    title: '餐饮连锁后厨卫生实名举报',
    heat: '5,987,234',
    tag: '社会热点',
    trend: 'up',
  },
];

const trendIcons: Record<string, { icon: string; color: string }> = {
  up: { icon: 'ri-arrow-up-line', color: 'text-primary-500' },
  down: { icon: 'ri-arrow-down-line', color: 'text-foreground-400' },
  new: { icon: 'ri-sparkling-line', color: 'text-accent-500' },
  hot: { icon: 'ri-fire-fill', color: 'text-primary-500' },
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热度榜单
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            实时热度排行，看看今天大家都在吃什么瓜
          </p>
        </div>

        <div className="space-y-2">
          {rankingData.map((item, idx) => (
            <div
              key={idx}
              className="flex items-center gap-3 md:gap-4 p-4 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-200 transition-colors"
            >
              {/* Rank */}
              <div className={`flex-shrink-0 w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg font-bold text-sm ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              {/* Content */}
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold text-foreground-900 text-sm md:text-base truncate">
                  {item.title}
                </h3>
              </div>

              {/* Tag */}
              <span className="hidden sm:inline-flex items-center px-2.5 py-0.5 rounded-full text-xs bg-secondary-100 text-secondary-700 flex-shrink-0 whitespace-nowrap">
                {item.tag}
              </span>

              {/* Trend */}
              <div className="flex items-center gap-1 flex-shrink-0">
                <i className={`${trendIcons[item.trend].icon} ${trendIcons[item.trend].color} text-sm`}></i>
              </div>

              {/* Heat */}
              <div className="flex-shrink-0 text-right min-w-[80px]">
                <div className="text-xs md:text-sm font-semibold text-foreground-800">
                  {item.heat}
                </div>
                <div className="text-[10px] text-foreground-400">热度值</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}